import { Container } from "@afas-doe-maar/ui/Container";
import { Logo } from "@afas-doe-maar/ui/Logo";
import { cn } from "@afas-doe-maar/ui/utils";

export function FullPageLoader() {
  return (
    <Container className="flex h-svh flex-col items-center justify-center gap-8">
      <Logo className="animate-in fade-in fill-mode-backwards max-w-[50%] delay-[2s] duration-[2s]" />
      <div className="animate-in fade-in fill-mode-backwards relative grid items-center justify-items-center delay-[2.5s] duration-[2s] *:col-span-full *:row-span-full">
        <Circle className="h-[50px] w-[50px]" style={{ animationDuration: "0.85s" }} />
        <Circle className="h-[75px] w-[75px]" style={{ animationDuration: "0.95s" }} />
        <Circle className="h-[100px] w-[100px]" style={{ animationDuration: "1.05s" }} />
      </div>
    </Container>
  );
}

function Circle({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      {...props}
      className={cn(
        "border-t-primary repeat-infinite animate-spin rounded-full border-4 border-r-transparent border-b-transparent border-l-transparent opacity-50 ease-linear",
        className,
      )}
    ></div>
  );
}
